import { createSlice } from "@reduxjs/toolkit";
import { CitroenStateProps } from "../interfaces/branchs";

const initialState: CitroenStateProps = {
    fetchingToken: "unknown",
    token: {
        message: "",
        token: "",
        time: 0,
        startTime: "",
        expirationTime: 0
    },
    error: "",
    fetchingModels: "unknown",
    models: [],
    fetchingVersions: "unknown",
    versions: [],
    versionSelected: undefined,
    oportunities: [],
    totalOportunities: 0,
    parsedOportunities: {},
    fetchingOportunities: "unknown",
    pictures: {},
    fetchingColors: "unknown",
    fetchingPictures: "unknown",
    colors: [],
    fetchingComunes: "unknown",
    comunes: [],
    fetchingRegions: "unknown",
    regions: [],
    dealerships: [],
    fetchingDealerships: "unknown",
    fetchingAdditionalsPrices: "unknown",
    fetchingCodigoPorContrato: "unknown",
    additionalsPrices: [],
    contractCodes: []
};

const citroenSlice = createSlice({
    name: "citroen",
    initialState,
    reducers: {
        getTokenCitroenRequest: (state, action) => {
            state.fetchingToken = "loading";
            if(action.payload === "rehydrate"){
                state.token = initialState.token;
            }
        },
        getTokenCitroenSuccess: (state, action) => {
            const fechaString = action.payload.fecha_expiracion;
            const [fecha, hora] = fechaString.split(' ');
            const [dia, mes, anio] = fecha.split('-');
            const [horas, minutos, segundos] = hora.split(':');
            const expirationTime = new Date(anio, mes - 1, dia, horas, minutos, segundos).getTime();
            state.fetchingToken = "success";
            state.token.message = action.payload.mensaje;
            state.token.token = action.payload.token;
            state.token.time = action.payload.time;
            state.token.startTime = action.payload.fecha_inicio;
            state.token.expirationTime = expirationTime;
        },
        getTokenCitroenFailure: (state, action) => {
            state.fetchingToken = "failure";
            state.error = action.payload;
        },
        cleanTokenCitroen: (state) => {
            state.token = initialState.token;
        },
        getModelsCitroenRequest: (state) => {
            state.fetchingModels = "loading";
        },
        getModelsCitroenSuccess: (state, action) => {
            state.fetchingModels = "success";
            state.models = action.payload
        },
        getModelsCitroenFailure: (state) => {
            state.fetchingModels = "failure";
        },
        getVersionsCitroenRequest: (state) => {
            state.fetchingVersions = "loading";
        },
        getVersionsCitroenSuccess: (state, action) => {
            state.fetchingVersions = "success";
            state.versions = action.payload
        },
        getVersionsCitroenFailure: (state) => {
            state.fetchingVersions = "failure";
        },
        setVersionSelected: (state, action) => {
            state.versionSelected = action.payload;
        },
        getOportunitiesRequest: (state) => {
            state.fetchingOportunities = "loading";
        },
        getOportunitiesSuccess: (state, action) => {
            state.fetchingOportunities = "success";
            state.oportunities = action.payload.oportunities;
            state.parsedOportunities = action.payload.responseParsed;
            state.totalOportunities = action.payload.total;
        },
        getOportunitiesFailure: (state) => {
            state.fetchingOportunities = "failure";
        },
        getCitroenColorsRequest: (state) => {
            state.fetchingColors = "loading";
        },
        getCitroenColorsSuccess: (state, action) => {
            state.fetchingColors = "success";
            state.colors = action.payload;
        },
        getCitroenColorsFailure: (state) => {
            state.fetchingColors = "failure";
        },
        cleanColors: (state) => {
            state.fetchingColors = "unknown";
            state.colors = initialState.colors;
        },
        getCitroenPicturesRequest: (state) => {
            state.fetchingPictures = "loading";
        },
        getCitroenPicturesSuccess: (state, action) => {
            state.fetchingPictures = "success";
            state.pictures = action.payload;
        },
        getCitroenPicturesFailure: (state) => {
            state.fetchingPictures = "failure";
        },
        cleanPictures: (state) => {
            state.pictures = initialState.pictures;
            state.fetchingPictures = initialState.fetchingPictures;
            state.versionSelected = initialState.versionSelected;
            state.versions = initialState.versions;
        },
        getCitroenComunesRequest: (state) => {
            state.fetchingComunes = "loading";
        },
        getCitroenComunesFailure: (state) => {
            state.fetchingComunes = "failure";
        },
        getCitroenComunesSuccess: (state,action) => {
            state.fetchingComunes = "success";
            state.comunes = action.payload;
        },
        getCitroenRegionsRequest: (state) => {
            state.fetchingRegions = "loading";
        },
        getCitroenRegionsFailure: (state) => {
            state.fetchingRegions = "failure";
        },
        getCitroenRegionsSuccess: (state,action) => {
            state.fetchingRegions = "success";
            state.regions = action.payload;
        },
        getCitroenDealershipsRequest: (state) => {
            state.fetchingDealerships = "loading";
        },
        getCitroenDealershipsFailure: (state) => {
            state.fetchingDealerships = "failure";
        },
        getCitroenDealershipsSuccess: (state,action) => {
            state.fetchingDealerships = "success";
            state.dealerships = action.payload;
        },
        getCitroenAdditionalPricesRequest: (state) => {
            state.fetchingAdditionalsPrices = "loading";
        },
        getCitroenAdditionalPricesFailure: (state) => {
            state.fetchingAdditionalsPrices = "failure";
            state.additionalsPrices = initialState.additionalsPrices;
        },
        getCitroenAdditionalPricesSuccess: (state,action) => {
            state.fetchingAdditionalsPrices = "success";
            state.additionalsPrices = action.payload;
        },
        getCodigoPorContratoRequest: (state) => {
            state.fetchingCodigoPorContrato = "loading";
        },
        getCodigoPorContratoFailure: (state) => {
            state.fetchingCodigoPorContrato = "failure";
        },
        getCodigoPorContratoSuccess: (state,action) => {
            state.fetchingCodigoPorContrato = "success";
            state.contractCodes = action.payload;
        },
        cleanSuccessOportunitiesFetching: (state) => {
            state.fetchingOportunities = initialState.fetchingOportunities;
        }
    },
});

export const {
    getTokenCitroenRequest,
    getTokenCitroenSuccess,
    getTokenCitroenFailure,
    cleanTokenCitroen,
    getModelsCitroenRequest,
    getModelsCitroenSuccess,
    getModelsCitroenFailure,
    getVersionsCitroenRequest,
    getVersionsCitroenSuccess,
    getVersionsCitroenFailure,
    setVersionSelected,
    getOportunitiesRequest,
    getOportunitiesSuccess,
    getOportunitiesFailure,
    getCitroenColorsRequest,
    getCitroenColorsSuccess,
    getCitroenColorsFailure,
    cleanColors,
    getCitroenPicturesFailure,
    getCitroenPicturesRequest,
    getCitroenPicturesSuccess,
    cleanPictures,
    cleanSuccessOportunitiesFetching,
    getCitroenComunesRequest,
    getCitroenComunesSuccess,
    getCitroenComunesFailure,
    getCitroenDealershipsRequest,
    getCitroenDealershipsFailure,
    getCitroenDealershipsSuccess,
    getCitroenRegionsRequest,
    getCitroenRegionsFailure,
    getCitroenRegionsSuccess,
    getCitroenAdditionalPricesRequest,
    getCitroenAdditionalPricesSuccess,
    getCitroenAdditionalPricesFailure,
    getCodigoPorContratoRequest,
    getCodigoPorContratoSuccess,
    getCodigoPorContratoFailure
} = citroenSlice.actions;

export default citroenSlice.reducer;